'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = gtm;

var _reactRouterRedux = require('react-router-redux');

var _gtm = require('../../actions/gtm');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function gtm() {
  return function (store) {
    return function (next) {
      return function (action) {
        var dataLayer = action.result && action.result.dataLayer;

        if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
          store.dispatch((0, _gtm.clearGtmDataLayer)());
        }

        if (dataLayer) {
          store.dispatch((0, _gtm.setGtmDataLayer)(dataLayer));

          if (__CLIENT__) {
            var _window$dataLayer;

            (_window$dataLayer = window.dataLayer).push.apply(_window$dataLayer, (0, _toConsumableArray3.default)(dataLayer));
          }
        }

        next(action);
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/store/middleware/gtm.js
// module id = 2354
// module chunks = 0